import React, { Component } from 'react'
import { withRouter } from 'react-router-dom';
import backgroundImage from '../assets/images/game-intro/bg.jpg'
import continueBtn from '../assets/images/game-intro/continue.png'

class GameIntro extends Component {

    btnSound = './sounds/button_sound.mp3';
    
    goToSelectPage() {
        this.playBtnSound();
        this.props.history.push({
            pathname: './select',
            state: {}
        });
    };

    playBtnSound() {
        let btnAudio = new Audio(this.btnSound);
        btnAudio.play();
    }

    render() {
        return (
            <div className='page-root-div'>
                <img alt='' src={backgroundImage} style={{ width: '100%', height: '100%', overflow: 'hidden', objectFit: 'cover', position: 'absolute' }}/>
                <img alt='' className='press-btn' src={continueBtn} style={{ position: 'absolute', height: '13%', right: '41%', bottom: '25.8%' }} onClick={this.goToSelectPage.bind(this)}/>
            </div>
        )
    }
}

export default withRouter(GameIntro);
